// This file is generated by scripts/generate-menu-sprite.js. Do not edit manually.
const MENU_SPRITE_ICON_IDS: Readonly<Record<string, string>> = {
  '/media/icons/duotune/menu/accept.svg': 'menu-accept-e26e30db',
  '/media/icons/duotune/menu/api-manage-users.svg': 'menu-api-manage-users-6ece69a8',
  '/media/icons/duotune/menu/api-services.svg': 'menu-api-services-10e795a2',
  '/media/icons/duotune/menu/api-users.svg': 'menu-api-users-5d5da998',
  '/media/icons/duotune/menu/api-users2.svg': 'menu-api-users2-8765f599',
  '/media/icons/duotune/menu/apuracao.svg': 'menu-apuracao-6946438d',
  '/media/icons/duotune/menu/apuracao2.svg': 'menu-apuracao2-2006bf29',
  '/media/icons/duotune/menu/apuracao3.svg': 'menu-apuracao3-91780566',
  '/media/icons/duotune/menu/apuracao4.svg': 'menu-apuracao4-3fccfd79',
  '/media/icons/duotune/menu/briefing-agent.svg': 'menu-briefing-agent-131cac53',
  '/media/icons/duotune/menu/briefing-history.svg': 'menu-briefing-history-e9b9aa83',
  '/media/icons/duotune/menu/briefing-promotion.svg': 'menu-briefing-promotion-b59fdef2',
  '/media/icons/duotune/menu/building.svg': 'menu-building-f44404bd',
  '/media/icons/duotune/menu/cadastro-lojista-interno.svg':
    'menu-cadastro-lojista-interno-09060b83',
  '/media/icons/duotune/menu/campaign.svg': 'menu-campaign-f0769cd6',
  '/media/icons/duotune/menu/cashback.svg': 'menu-cashback-69010c89',
  '/media/icons/duotune/menu/chip-ai.svg': 'menu-chip-ai-e68edee8',
  '/media/icons/duotune/menu/conecta/assoc_promoid_cupomid.svg':
    'menu-conecta-assoc_promoid_cupomid-85a96b06',
  '/media/icons/duotune/menu/conecta/blocklist-industria.svg':
    'menu-conecta-blocklist-industria-d7a30c75',
  '/media/icons/duotune/menu/conecta/blocklist-seller.svg':
    'menu-conecta-blocklist-seller-5609ac42',
  '/media/icons/duotune/menu/conecta/categoria.svg': 'menu-conecta-categoria-5e2895ba',
  '/media/icons/duotune/menu/conecta/comp_benef_valor.svg':
    'menu-conecta-comp_benef_valor-732aedd9',
  '/media/icons/duotune/menu/conecta/conecta-extrato-lojista-company-cnpj.svg':
    'menu-conecta-conecta-extrato-lojista-company-cnpj-111625de',
  '/media/icons/duotune/menu/conecta/conecta-extrato-lojista-customer-cnpj.svg':
    'menu-conecta-conecta-extrato-lojista-customer-cnpj-5948de28',
  '/media/icons/duotune/menu/conecta/conecta-x-ifc.svg': 'menu-conecta-conecta-x-ifc-83cbfa18',
  '/media/icons/duotune/menu/conecta/conecta.svg': 'menu-conecta-conecta-c11bbfa6',
  '/media/icons/duotune/menu/conecta/credit-limit.svg': 'menu-conecta-credit-limit-f5738960',
  '/media/icons/duotune/menu/conecta/devit-distribuidores.svg':
    'menu-conecta-devit-distribuidores-55c07f0b',
  '/media/icons/duotune/menu/conecta/devit-lojistas.svg': 'menu-conecta-devit-lojistas-97b5388d',
  '/media/icons/duotune/menu/conecta/devit-vendedores.svg':
    'menu-conecta-devit-vendedores-9e59d811',
  '/media/icons/duotune/menu/conecta/devit.svg': 'menu-conecta-devit-0dd2ae63',
  '/media/icons/duotune/menu/conecta/diferencas/blocklist-seller.svg':
    'menu-conecta-diferencas-blocklist-seller-78c51c03',
  '/media/icons/duotune/menu/conecta/diferencas/industrias.svg':
    'menu-conecta-diferencas-industrias-2b65d80b',
  '/media/icons/duotune/menu/conecta/diferencas/lojista-company.svg':
    'menu-conecta-diferencas-lojista-company-2a6eafb6',
  '/media/icons/duotune/menu/conecta/diferencas/lojista-customer.svg':
    'menu-conecta-diferencas-lojista-customer-7109447c',
  '/media/icons/duotune/menu/conecta/diferencas/lojista.svg':
    'menu-conecta-diferencas-lojista-837f19fd',
  '/media/icons/duotune/menu/conecta/diferencas/marcas.svg':
    'menu-conecta-diferencas-marcas-e3f40591',
  '/media/icons/duotune/menu/conecta/diferencas/pedidos.svg':
    'menu-conecta-diferencas-pedidos-5b28b7f0',
  '/media/icons/duotune/menu/conecta/diferencas/produto.svg':
    'menu-conecta-diferencas-produto-5c86e161',
  '/media/icons/duotune/menu/conecta/diferencas/sellers-group.svg':
    'menu-conecta-diferencas-sellers-group-c8067e31',
  '/media/icons/duotune/menu/conecta/diferencas/sellers.svg':
    'menu-conecta-diferencas-sellers-3f308e34',
  '/media/icons/duotune/menu/conecta/diferencas/vendedores.svg':
    'menu-conecta-diferencas-vendedores-6947c841',
  '/media/icons/duotune/menu/conecta/diferencas.svg': 'menu-conecta-diferencas-aa4e560d',
  '/media/icons/duotune/menu/conecta/extract.svg': 'menu-conecta-extract-5cef8128',
  '/media/icons/duotune/menu/conecta/freshdesk-distribuidor.svg':
    'menu-conecta-freshdesk-distribuidor-91681353',
  '/media/icons/duotune/menu/conecta/freshdesk-lojista-company.svg':
    'menu-conecta-freshdesk-lojista-company-0662b244',
  '/media/icons/duotune/menu/conecta/freshdesk-lojista-contact.svg':
    'menu-conecta-freshdesk-lojista-contact-d14247ee',
  '/media/icons/duotune/menu/conecta/freshdesk-vendedor.svg':
    'menu-conecta-freshdesk-vendedor-8c0b1305',
  '/media/icons/duotune/menu/conecta/freshdesk.svg': 'menu-conecta-freshdesk-93cc5eeb',
  '/media/icons/duotune/menu/conecta/grupo-lojista-open.svg':
    'menu-conecta-grupo-lojista-open-3068f954',
  '/media/icons/duotune/menu/conecta/grupo-lojista-root.svg':
    'menu-conecta-grupo-lojista-root-907a3228',
  '/media/icons/duotune/menu/conecta/grupo-lojista.svg': 'menu-conecta-grupo-lojista-9aedc13a',
  '/media/icons/duotune/menu/conecta/grupo-vendedor.svg': 'menu-conecta-grupo-vendedor-e4174c8c',
  '/media/icons/duotune/menu/conecta/industria.svg': 'menu-conecta-industria-aee9580c',
  '/media/icons/duotune/menu/conecta/lojista-company.svg': 'menu-conecta-lojista-company-e17598bd',
  '/media/icons/duotune/menu/conecta/lojista-customer.svg':
    'menu-conecta-lojista-customer-eece6750',
  '/media/icons/duotune/menu/conecta/lojista.svg': 'menu-conecta-lojista-3da4a241',
  '/media/icons/duotune/menu/conecta/marca.svg': 'menu-conecta-marca-85aa7d99',
  '/media/icons/duotune/menu/conecta/pedidos.svg': 'menu-conecta-pedidos-c12f9f38',
  '/media/icons/duotune/menu/conecta/produto.svg': 'menu-conecta-produto-596c6350',
  '/media/icons/duotune/menu/conecta/seller-group.svg': 'menu-conecta-seller-group-15a49afc',
  '/media/icons/duotune/menu/conecta/seller-mapping.svg': 'menu-conecta-seller-mapping-08aca1a9',
  '/media/icons/duotune/menu/conecta/seller.svg': 'menu-conecta-seller-73fad2fa',
  '/media/icons/duotune/menu/conecta/store-shop-svgrepo-com.svg':
    'menu-conecta-store-shop-svgrepo-com-958bb8f5',
  '/media/icons/duotune/menu/conecta/ul-nao-ponderada.svg':
    'menu-conecta-ul-nao-ponderada-341c0566',
  '/media/icons/duotune/menu/conecta/ul-ponderada.svg': 'menu-conecta-ul-ponderada-5a2d38ee',
  '/media/icons/duotune/menu/conecta/validacao/cnpjmigrado.svg':
    'menu-conecta-validacao-cnpjmigrado-12a9301b',
  '/media/icons/duotune/menu/conecta/validacao/email.svg': 'menu-conecta-validacao-email-b91d03b7',
  '/media/icons/duotune/menu/conecta/validacao/estoque.svg':
    'menu-conecta-validacao-estoque-f933dc39',
  '/media/icons/duotune/menu/conecta/validacao/golive.svg':
    'menu-conecta-validacao-golive-e8d85e56',
  '/media/icons/duotune/menu/conecta/validacao/sellermapping.svg':
    'menu-conecta-validacao-sellermapping-190631ad',
  '/media/icons/duotune/menu/conecta/validacao/telefone.svg':
    'menu-conecta-validacao-telefone-fa7f7a40',
  '/media/icons/duotune/menu/conecta/validacao/validacao.svg':
    'menu-conecta-validacao-validacao-4e6bbade',
  '/media/icons/duotune/menu/conecta/vendedor.svg': 'menu-conecta-vendedor-b4d71349',
  '/media/icons/duotune/menu/conecta/vip.svg': 'menu-conecta-vip-a07f28cb',
  '/media/icons/duotune/menu/conecta/voucher-primario.svg':
    'menu-conecta-voucher-primario-90be610c',
  '/media/icons/duotune/menu/conecta/voucher-secundario.svg':
    'menu-conecta-voucher-secundario-3e5fcdf6',
  '/media/icons/duotune/menu/coupon.svg': 'menu-coupon-5a18c61d',
  '/media/icons/duotune/menu/coupon2.svg': 'menu-coupon2-84e89780',
  '/media/icons/duotune/menu/datatransfer/data-transfer.svg':
    'menu-datatransfer-data-transfer-d44480f1',
  '/media/icons/duotune/menu/datatransfer/meta-financeira.svg':
    'menu-datatransfer-meta-financeira-c1ba2bb6',
  '/media/icons/duotune/menu/datatransfer/metasUL.svg': 'menu-datatransfer-metasul-850801e9',
  '/media/icons/duotune/menu/datatransfer/multipatrocinadores.svg':
    'menu-datatransfer-multipatrocinadores-4db3f029',
  '/media/icons/duotune/menu/datatransfer/multipatrocinadores2.svg':
    'menu-datatransfer-multipatrocinadores2-063f90d1',
  '/media/icons/duotune/menu/datatransfer/nao-faturado.svg':
    'menu-datatransfer-nao-faturado-a582713a',
  '/media/icons/duotune/menu/datatransfer/spreadsheet.svg':
    'menu-datatransfer-spreadsheet-ac078061',
  '/media/icons/duotune/menu/datatransfer/timegap.svg': 'menu-datatransfer-timegap-2af719fe',
  '/media/icons/duotune/menu/devops-dashboard.svg': 'menu-devops-dashboard-922bda0a',
  '/media/icons/duotune/menu/devops-history.svg': 'menu-devops-history-ede5457b',
  '/media/icons/duotune/menu/devops-panel.svg': 'menu-devops-panel-12a13e72',
  '/media/icons/duotune/menu/devops-servers.svg': 'menu-devops-servers-9a3dd182',
  '/media/icons/duotune/menu/devops-sprints.svg': 'menu-devops-sprints-15a40dac',
  '/media/icons/duotune/menu/devops-tasks.svg': 'menu-devops-tasks-238ff29d',
  '/media/icons/duotune/menu/devops-team.svg': 'menu-devops-team-1973df67',
  '/media/icons/duotune/menu/devops-users.svg': 'menu-devops-users-15f20c62',
  '/media/icons/duotune/menu/document-sheet.svg': 'menu-document-sheet-fbc7592b',
  '/media/icons/duotune/menu/document.svg': 'menu-document-fdd76ac1',
  '/media/icons/duotune/menu/home.svg': 'menu-home-ca7410e8',
  '/media/icons/duotune/menu/icon-alerts.svg': 'menu-icon-alerts-be3dc24e',
  '/media/icons/duotune/menu/icon-ativacao.svg': 'menu-icon-ativacao-ca0864e2',
  '/media/icons/duotune/menu/icon-cadastro.svg': 'menu-icon-cadastro-424bb150',
  '/media/icons/duotune/menu/icon-listas.svg': 'menu-icon-listas-d4dfc2f2',
  '/media/icons/duotune/menu/icon-logs.svg': 'menu-icon-logs-09e1914f',
  '/media/icons/duotune/menu/icon-positivacao.svg': 'menu-icon-positivacao-613e35a5',
  '/media/icons/duotune/menu/icon-regional.svg': 'menu-icon-regional-cd8bce8d',
  '/media/icons/duotune/menu/infrapay-historico-vouchers.svg':
    'menu-infrapay-historico-vouchers-497d092c',
  '/media/icons/duotune/menu/infrapay-report.svg': 'menu-infrapay-report-c6f7dd93',
  '/media/icons/duotune/menu/infrapay.svg': 'menu-infrapay-0ae5b273',
  '/media/icons/duotune/menu/lists.svg': 'menu-lists-d7fd0305',
  '/media/icons/duotune/menu/lists2.svg': 'menu-lists2-806bc455',
  '/media/icons/duotune/menu/magnifying.svg': 'menu-magnifying-4b8753aa',
  '/media/icons/duotune/menu/management.svg': 'menu-management-27a070f8',
  '/media/icons/duotune/menu/menu-ids-ecoa.svg': 'menu-menu-ids-ecoa-c0c4f948',
  '/media/icons/duotune/menu/permissions.svg': 'menu-permissions-f2fbe6e8',
  '/media/icons/duotune/menu/permissions2.svg': 'menu-permissions2-7e40e2dc',
  '/media/icons/duotune/menu/region.svg': 'menu-region-ae590bd0',
  '/media/icons/duotune/menu/remove.svg': 'menu-remove-ebd0d4da',
  '/media/icons/duotune/menu/report.svg': 'menu-report-22388601',
  '/media/icons/duotune/menu/reports/cadastro-lojistas.svg':
    'menu-reports-cadastro-lojistas-e4dcd57d',
  '/media/icons/duotune/menu/reports/cadastro-produtos.svg':
    'menu-reports-cadastro-produtos-211eeb04',
  '/media/icons/duotune/menu/reports/cadastro-vendedores.svg':
    'menu-reports-cadastro-vendedores-933f88b4',
  '/media/icons/duotune/menu/reports/distribuidor-prioritario.svg':
    'menu-reports-distribuidor-prioritario-95b2e682',
  '/media/icons/duotune/menu/reports/faixa-cep-lojista.svg':
    'menu-reports-faixa-cep-lojista-33f6c1ff',
  '/media/icons/duotune/menu/reports/master-produto.svg': 'menu-reports-master-produto-432c3ebe',
  '/media/icons/duotune/menu/reports/nota-fiscal.svg': 'menu-reports-nota-fiscal-232dac55',
  '/media/icons/duotune/menu/reports/pedidos.svg': 'menu-reports-pedidos-a485f819',
  '/media/icons/duotune/menu/reports/promocoes.svg': 'menu-reports-promocoes-c02d0409',
  '/media/icons/duotune/menu/reports/reports.svg': 'menu-reports-reports-550e5069',
  '/media/icons/duotune/menu/reports/ultimo-preco-estoque.svg':
    'menu-reports-ultimo-preco-estoque-f585e01f',
  '/media/icons/duotune/menu/reports.svg': 'menu-reports-c9be017c',
  '/media/icons/duotune/menu/robot-ai-svgrepo-com.svg': 'menu-robot-ai-svgrepo-com-5f3d9f60',
  '/media/icons/duotune/menu/ruler.svg': 'menu-ruler-e470446d',
  '/media/icons/duotune/menu/seller-group.svg': 'menu-seller-group-4919965c',
  '/media/icons/duotune/menu/settings.svg': 'menu-settings-35da9bc1',
  '/media/icons/duotune/menu/size.svg': 'menu-size-0a45bb09',
  '/media/icons/duotune/menu/spreadsheet.svg': 'menu-spreadsheet-fc7a6d7a',
  '/media/icons/duotune/menu/store.svg': 'menu-store-db83b348',
  '/media/icons/duotune/menu/unilever-white.svg': 'menu-unilever-white-fe1403c2',
  '/media/icons/duotune/menu/unilever.svg': 'menu-unilever-3e058246',
}

const MENU_SPRITE_URL = '/media/icons/duotune/menu-sprite.svg?v=207ec2cfc97d'

export function getMenuSpriteHref(icon?: string): string | null {
  if (!icon) return null

  const normalizedIcon = icon.split(/[?#]/, 1)[0]
  const symbolId = MENU_SPRITE_ICON_IDS[normalizedIcon]

  return symbolId ? MENU_SPRITE_URL + '#' + symbolId : null
}
